var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useMemo, useRef } from "react";
import Box from "../Box";
import TextField from "../TextField";
import { DoneIcon } from "../icons";
import { Autocomplete, Popper, createFilterOptions, styled } from "../../mui";
var AutocompleteContainer = styled(Autocomplete)(function (_a) {
    var open = _a.open, size = _a.size;
    return ({
        position: "absolute",
        width: size === "small" ? 80 : 100,
        left: 0,
        top: 0,
        "& .MuiOutlinedInput-notchedOutline": {
            borderLeft: "none",
            borderTop: "none",
            borderBottom: "none",
            borderRadius: 0,
            height: size === "small" ? 39.5 : "auto",
            borderRightColor: open ? "#4caf50" : "rgba(0, 0, 0, 0.08)",
        },
    });
});
var PopComponent = styled(Popper)(function (_a) {
    var theme = _a.theme;
    return ({
        width: "240px !important",
        marginLeft: "70px !important",
        marginTop: "4px !important",
        maxHeight: 380,
        overflow: "auto",
        "& .MuiAutocomplete-listbox": {
            "& .MuiListSubheader-root": {
                height: 24,
                paddingLeft: theme.spacing(1),
                fontWight: 400,
                top: 0,
                color: theme.palette.secondary,
                backgroundColor: "#F4F4F4",
            },
            "& .MuiAutocomplete-option": {
                paddingLeft: theme.spacing(2),
                paddingRight: theme.spacing(1),
                fontSize: 14,
                backgroundColor: "#fff !important",
                "&:hover": {
                    backgroundColor: "#F4F4F4 !important",
                },
            },
        },
    });
});
var TextFieldContainer = styled(TextField)(
// @ts-ignore
function (_a) {
    var open = _a.open, inputValue = _a.inputValue, areaValue = _a.areaValue, size = _a.size;
    return ({
        height: "auto",
        "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
            backgroundColor: "transparent",
        },
        "& .MuiAutocomplete-endAdornment>.MuiButtonBase-root>.MuiSvgIcon-root": {
            color: "rgba(0, 0, 0, 0.56)",
        },
        "& .MuiOutlinedInput-root.MuiInputBase-root": {
            paddingTop: size === "small" ? "6px" : "4px",
            paddingBottom: "6px",
            position: "relative",
            "&:before": __assign({ position: "absolute", left: 15, content: '""', color: "rgba(0, 0, 0, 0.86)" }, (open &&
                !inputValue && {
                content: "\"" + areaValue + "\"",
                color: "rgba(0, 0, 0, 0.26)",
                whiteSpace: "nowrap",
            })),
        },
    });
});
var filterOptions = createFilterOptions({
    matchFrom: "any",
    stringify: function (option) { var _a, _b; return "" + ((_a = option) === null || _a === void 0 ? void 0 : _a.value) + ((_b = option) === null || _b === void 0 ? void 0 : _b.label); },
});
var MobileArea = function (_a) {
    var area = _a.area, onOpenChange = _a.onOpenChange, onChange = _a.onChange, size = _a.size, options = _a.options, open = _a.open, disabled = _a.disabled, defaultMobile = _a.defaultMobile;
    var mobileRef = useRef(null);
    var handleOpen = function () {
        onOpenChange(true);
    };
    var handleClose = function () {
        onOpenChange(false);
    };
    var handleChange = function (_event, val) {
        onChange(val);
    };
    useEffect(function () {
        onOpenChange(open);
    }, [open]);
    var handleFocus = function () {
        var _a, _b;
        (_b = (_a = mobileRef.current) === null || _a === void 0 ? void 0 : _a.firstElementChild) === null || _b === void 0 ? void 0 : _b.classList.add("Mui-focused");
    };
    var handleBlur = function () {
        var _a, _b;
        (_b = (_a = mobileRef.current) === null || _a === void 0 ? void 0 : _a.firstElementChild) === null || _b === void 0 ? void 0 : _b.classList.remove("Mui-focused");
    };
    useEffect(function () {
        mobileRef.current = document.getElementById("mobile-text");
    }, []);
    useEffect(function () {
        if (!area) {
            var mobileArea = options === null || options === void 0 ? void 0 : options.find(function (n) { return n.key === (defaultMobile.mobileAreaCode || "CN_243"); });
            onChange === null || onChange === void 0 ? void 0 : onChange(mobileArea);
        }
    }, [area, defaultMobile, options]);
    var value = useMemo(function () { return (__assign({}, (area || {}))); }, [area]);
    return (React.createElement(AutocompleteContainer, { disableClearable: true, open: open, size: size, value: value, disabled: disabled, PopperComponent: PopComponent, options: options, filterOptions: filterOptions, onFocus: handleFocus, onBlur: handleBlur, groupBy: function (option) { var _a; return (_a = option) === null || _a === void 0 ? void 0 : _a.group; }, getOptionLabel: function (option) { var _a; return "" + ((_a = option) === null || _a === void 0 ? void 0 : _a.value); }, 
        // @ts-ignore
        onChange: handleChange, isOptionEqualToValue: function (o, v) { var _a, _b; return ((_a = v) === null || _a === void 0 ? void 0 : _a.key) === ((_b = o) === null || _b === void 0 ? void 0 : _b.key); }, openOnFocus: true, 
        // inputValue={open ? value : area.value}
        // onInputChange={handleChangeValue}
        renderOption: function (props, option, _a) {
            var _b, _c;
            var selected = _a.selected;
            return (React.createElement("li", __assign({}, props),
                React.createElement(Box, { sx: {
                        flexGrow: 1,
                    } }, ((_b = option) === null || _b === void 0 ? void 0 : _b.label) + " " + ((_c = option) === null || _c === void 0 ? void 0 : _c.value)),
                React.createElement(Box, { component: DoneIcon, sx: { width: 24, height: 24 }, style: {
                        color: "#4CAF50",
                        visibility: selected ? "visible" : "hidden",
                    } })));
        }, onOpen: handleOpen, onClose: handleClose, renderInput: function (params) {
            var _a;
            return (React.createElement(TextFieldContainer, __assign({}, params, { size: size, open: open, inputValue: (_a = params === null || params === void 0 ? void 0 : params.inputProps) === null || _a === void 0 ? void 0 : _a.value, areaValue: value === null || value === void 0 ? void 0 : value.value })));
        } }));
};
export default MobileArea;
